import { useDeps } from 'src/hooks/useDeps';

export function useUrlForPath(path: string) {
    const { DOMAIN } = useDeps().env;
    return ['https://', [DOMAIN, path].join('/')].join('');
}
